import Vue from 'vue';
import VueRouter from 'vue-router';
import App from '@/App.vue';
import MainViewLayout from '@/views/MainViewLayout.vue';
import ErrorView from '@/views/errors/ErrorView.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: () => {
      if (process.env.NODE_ENV === 'development') {
        const tenantId = process.env.TENANT;
        return {
          path: `/${tenantId}/associations`,
          query: { title: 'dev_env', lat: 0, long: 0, titleLevel: 0 },
        };
      } else {
        //! When in production there is no redirection, the error route is always called if the whole route is not matching
        return { name: 'errorRoute' };
      }
    },
  },
  {
    path: '/:tenantId', //! there are no verification if the tenant is a legit one, future requests will just fail
    name: 'tenantRoute',
    component: App,
    redirect: () => {
      if (process.env.NODE_ENV === 'development') {
        return { name: `associationsRoute`, query: { title: 'dev_env', lat: 0, long: 0, titleLevel: 0 } };
      } else {
        return { name: 'errorRoute' }; //! the whole route needs to match in production
      }
    },
    children: [
      {
        path: 'associations', //? ex: /#/padev2bis/associations
        name: 'associationsRoute',
        component: MainViewLayout,
        props: (route) => ({
          //? workaround to detect if we are on mobile, see https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent at the end
          mobile: navigator.userAgent.includes('Mobi'),
        }),
      },
    ],
  },
  {
    path: '*',
    name: 'errorRoute',
    component: ErrorView,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
